mx.plugin.metadataDrivenForm = function(config) {
    Ext.apply(this, config);
};
Ext.extend(mx.plugin.metadataDrivenForm, Ext.util.Observable, {
    metadataEndpoint: null,
    form: null,
    fields: {},
    /**
     * @example:
     * {
     *   TYPE1: [{name: "elementName", type: com.magenta.maxoptra.metadata.AttributeType, readOnly: false, required: false, defaultValue: "1"}, {}, ...]
     *   TYPE2: [{}, {}, ...]
     *   ...
     *  }
     */
    metadata: {},
    defaultMetaType: null,
    init: function(component) {
        this.form = component;
        if (this.metadataEndpoint != null) {
            this.form.on(
                'render',
                function() {
                    this.scanAttributedFields();
                    this.readMetadata();
                },
                this
            );
        }
        component.switchMetaType = this.switchMetaType.createDelegate(this);
        component.hideAllAttributeFields = this.hideAllAttributeFields.createDelegate(this);

        var populateRecordWithAttributes = function(form, record) {
            form.getForm().items.each(function(field) {
                var isMetadataDriven = field.isMetadataDriven && field.isMetadataDriven();
                if (isMetadataDriven && field.getAttributeName) {
                    if (!record.data.attributeValues) {
                        record.data.attributeValues = new Object();
                    }
                    if (field.isSwitchedOn() && field.getValue) {
                        record.data.attributeValues[field.getAttributeName()] = field.getValue();
                    } else {
                        delete record.data.attributeValues[field.getAttributeName()];
                    }
                }
            }, this);
        };
        component.on('beforeSubmitAfterValidation', populateRecordWithAttributes, this);
    },
    scanAttributedFields: function() {
        for (var i in this.form.els) {
            if (this.form.els[i].isMetadataDriven && this.form.els[i].isMetadataDriven()) {
                this.fields[this.form.els[i].getAttributeName()] = this.form.els[i];
            }
        }
    },
    readMetadata: function() {
        this.form.el.mask(MXBT.loc('mx.app.core.termins', 'loading'));
        Ext.Ajax.request({
            url: this.metadataEndpoint,
            method: 'GET',
            params: {},
            scope: this,
            success: function(r) {
                var response = Ext.util.JSON.decode(r.responseText);
                if (response.success) {
                    this.form.el.unmask();
                    this.metadata = response.rows[0];
                    this.hideAllAttributeFields();
                    if (this.defaultMetaType) {
                        this.switchMetaType(this.defaultMetaType);
                    }
                }
            },
        });
    },
    hideAllAttributeFields: function() {
        for (var i in this.form.els) {
            if (this.form.els[i].isMetadataDriven && this.form.els[i].isMetadataDriven()) {
                this.hideField(this.form.els[i].getAttributeName());
            }
        }
    },
    hideField: function(fieldName) {
        if (this.fields[fieldName]) {
            var el = this.fields[fieldName];
            if (el.hideWithLabel) {
                el.hideWithLabel();
            } else if (el.hide) {
                el.hide();
            }
            if (el.switchOff) {
                el.switchOff();
            }
            if (el.AllowBlank) {
                el.AllowBlank();
            }
        }
    },
    showField: function(fieldName, meta) {
        if (this.fields[fieldName]) {
            var el = this.fields[fieldName];
            if (el.showWithLabel) {
                el.showWithLabel();
            } else if (el.showWithLabel) {
                el.showWithLabel();
            }
            if (el.switchOn) {
                el.switchOn();
            }

            if (el.DisallowBlank && meta.required) {
                el.DisallowBlank();
            }

            if (el.setDisabled) {
                if (meta.readOnly) {
                    el.setDisabled(true);
                } else if (!el.initiallyDisabled) {
                    el.setDisabled(false);
                }
            }

            if (el.getValue) {
                if (!el.getValue() && meta.defaultValue) {
                    if (meta.type == 'BOOLEAN') {
                        el.setValue(meta.defaultValue == 'true');
                    } else {
                        el.setValue(meta.defaultValue);
                    }
                }
            }
        }
    },
    switchMetaType: function(/* String */ metatype) {
        this.hideAllAttributeFields();
        for (var type in this.metadata) {
            for (var i = 0; i < this.metadata[metatype].length; i++) {
                this.showField(this.metadata[metatype][i]['name'], this.metadata[metatype][i]);
            }
        }
    },
});
